// extracted by mini-css-extract-plugin
export default {"wrapper":"InvoiceList_wrapper__ZqUSD","invoice":"InvoiceList_invoice__t-oXW","invoiceBg":"InvoiceList_invoiceBg__KSM7j","invoiceTitle":"InvoiceList_invoiceTitle__WIsmQ"};